module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noVacancyLists":"You have not created any job selections yet","badLists":"Some selections are empty (all jobs have been archived)"}}')
  delete Component.options._Ctor
}
